import * as $ from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import Spinner from 'Core/Spinner';
import {getCurrentLanguage} from "Core/Languages";
import {onLoad} from 'Core/Events';

export class PlannerSubProcessCommon {
    private static spinner = Spinner;
    private static modal = $(PlannerSelectors.MODAL.MODAL_ID);
    public static readonly ajaxUrl = `/${getCurrentLanguage}/planner_service/`

    @onLoad(PlannerSubProcessCommon.showModalOnInit)

    /**
     * Czy planer został zaiinicjowany
     */
    public static isPlanerInit() {
        return $(PlannerSelectors.MODAL.MODAL_CONTENT_ID).length > 0 ? true : false;
    }

    /**
     * Włącza modal
     */
    public static modalOn() {
        PlannerSubProcessCommon.modal.modal('show');
    }

    /**
     * Wyłacza modal
     */
    public static modalOff() {
        PlannerSubProcessCommon.modal.modal('hide');
    }

    /**
     * Ustawia treść na modalu
     */
    public static setContentOnModal(content) {
        $(PlannerSelectors.MODAL.MODAL_CONTENT_ID).html(content);
    }

    /**
     * Ustawia na modalu spinner
     */
    public static setSpinnerOnModal() {
        PlannerSubProcessCommon.spinner.plannerSpinner(PlannerSelectors.MODAL.MODAL_CONTENT_ID, true);
    }

    /**
     * Uruchamia modal domyślnie po uruchomieniu strony
     */
    public static showModalOnInit() {
        let defaultShow = $(PlannerSelectors.MODAL.MODAL_ID).data('default-show');
        if(defaultShow == true){
            PlannerSubProcessCommon.modalOn();
        }
    }

    /**
     * Prezentuje modal o wygasnietej sesji
     */
    public static loadAndDisplayModalSessionHasExpired() {
        PlannerSubProcessCommon.setSpinnerOnModal();
        PlannerSubProcessCommon.modalOn();
        PlannerSubProcessCommon.loadModalSessionHasExpired()
            .done((response) => {
                PlannerSubProcessCommon.setContentOnModal(response)
            });
    }

    /**
     * Doczytanie i wkomponowanie formularza do logowania
     */
    public static emergencyLoadingOfLoginForm() {
        return PlannerSubProcessCommon.loadLoginFormTpl()
            .done((response) => {
                $(PlannerSelectors.SIGN_OUT).remove();
                $(PlannerSelectors.ACCOUNT_BTN ).replaceWith(response.btn);
                $(PlannerSelectors.MAIN_HEADER).append(response.loginPanelModal);
            });
    }

    /**
     * Sprawdza czy użytkownik jest zalogowany
     */
    public static isUserLogged(){
        return $.ajax({
            url:  `${PlannerSubProcessCommon.ajaxUrl}is_logged/`,
            method: 'POST',
            dataType: 'json'
        })
    }

    /**
     * Zwraca fragmenty tpl potrzebne do zalogowania
     */
    public static loadLoginFormTpl(){
        return $.ajax({
            url:  `${PlannerSubProcessCommon.ajaxUrl}load_login_form_tpl/`,
            method: 'POST',
            dataType: 'json'
        })
    }

    /**
     * Zwraca modal o wygaśniętej sesji
     */
    public static loadModalSessionHasExpired() {
        return $.ajax({
            url: `${PlannerSubProcessCommon.ajaxUrl}load_modal_session_has_expired/`,
            method: 'POST',
            dataType: 'html'
        })
    }

}import * as $ from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import Spinner from 'Core/Spinner';
import {getCurrentLanguage} from "Core/Languages";
import {onLoad} from 'Core/Events';

export class PlannerSubProcessCommon {
    private static spinner = Spinner;
    private static modal = $(PlannerSelectors.MODAL.MODAL_ID);
    public static readonly ajaxUrl = `/${getCurrentLanguage}/planner_service/`

    @onLoad(PlannerSubProcessCommon.showModalOnInit)

    /**
     * Czy planer został zaiinicjowany
     */
    public static isPlanerInit() {
        return $(PlannerSelectors.MODAL.MODAL_CONTENT_ID).length > 0 ? true : false;
    }

    /**
     * Włącza modal
     */
    public static modalOn() {
        PlannerSubProcessCommon.modal.modal('show');
    }

    /**
     * Wyłacza modal
     */
    public static modalOff() {
        PlannerSubProcessCommon.modal.modal('hide');
    }

    /**
     * Ustawia treść na modalu
     */
    public static setContentOnModal(content) {
        $(PlannerSelectors.MODAL.MODAL_CONTENT_ID).html(content);
    }

    /**
     * Ustawia na modalu spinner
     */
    public static setSpinnerOnModal() {
        PlannerSubProcessCommon.spinner.plannerSpinner(PlannerSelectors.MODAL.MODAL_CONTENT_ID, true);
    }

    /**
     * Uruchamia modal domyślnie po uruchomieniu strony
     */
    public static showModalOnInit() {
        let defaultShow = $(PlannerSelectors.MODAL.MODAL_ID).data('default-show');
        if(defaultShow == true){
            PlannerSubProcessCommon.modalOn();
        }
    }

    /**
     * Prezentuje modal o wygasnietej sesji
     */
    public static loadAndDisplayModalSessionHasExpired() {
        PlannerSubProcessCommon.setSpinnerOnModal();
        PlannerSubProcessCommon.modalOn();
        PlannerSubProcessCommon.loadModalSessionHasExpired()
            .done((response) => {
                PlannerSubProcessCommon.setContentOnModal(response)
            });
    }

    /**
     * Doczytanie i wkomponowanie formularza do logowania
     */
    public static emergencyLoadingOfLoginForm() {
        return PlannerSubProcessCommon.loadLoginFormTpl()
            .done((response) => {
                $(PlannerSelectors.SIGN_OUT).remove();
                $(PlannerSelectors.ACCOUNT_BTN ).replaceWith(response.btn);
                $(PlannerSelectors.MAIN_HEADER).append(response.loginPanelModal);
            });
    }

    /**
     * Sprawdza czy użytkownik jest zalogowany
     */
    public static isUserLogged(){
        return $.ajax({
            url:  `${PlannerSubProcessCommon.ajaxUrl}is_logged/`,
            method: 'POST',
            dataType: 'json'
        })
    }

    /**
     * Zwraca fragmenty tpl potrzebne do zalogowania
     */
    public static loadLoginFormTpl(){
        return $.ajax({
            url:  `${PlannerSubProcessCommon.ajaxUrl}load_login_form_tpl/`,
            method: 'POST',
            dataType: 'json'
        })
    }

    /**
     * Zwraca modal o wygaśniętej sesji
     */
    public static loadModalSessionHasExpired() {
        return $.ajax({
            url: `${PlannerSubProcessCommon.ajaxUrl}load_modal_session_has_expired/`,
            method: 'POST',
            dataType: 'html'
        })
    }

}